import React from "react";
import { Navigate } from "react-router-dom";
import { getCurrentAppRole, AppRole } from "utils/auth";

interface ProtectedRouteProps {
  /** Roles allowed to access this route. */
  allowedRoles: AppRole[];
  children: React.ReactElement;
}

/**
 * Wraps a route and redirects unauthenticated or unauthorized users.
 * - Not logged in       → /auth/sign-in
 * - Wrong role          → home path of their actual role
 */
const ProtectedRoute = ({ allowedRoles, children }: ProtectedRouteProps) => {
  const role = getCurrentAppRole();

  if (!role) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  if (!allowedRoles.includes(role)) {
    // Redirect to their correct home instead of showing 403
    const home =
      role === "admin"
        ? "/admin"
        : role === "systemadmin"
        ? "/systemadmin"
        : "/user";
    return <Navigate to={home} replace />;
  }

  return children;
};

export default ProtectedRoute;
